var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"msg-box"},[_c('h1',{staticClass:"animated fadeInDown"},[_vm._v("500 Server error!")]),_c('h2',{staticClass:"animated fadeInUp"},[_vm._v(" Oops!"),_c('br'),_vm._v("Parece que tenemos un error en el servidor. ")])])])
}]

export { render, staticRenderFns }